module.exports = __webpack_public_path__ + "static/media/Start.37ef55ae.svg";